import React from 'react';
import './Header.css';
import HeaderImage from '../../assets/sasuke.jpg';
import data from './data';
import { useTypingEffect } from '../typing-effect';
import { Typewriter } from 'react-simple-typewriter';
import { FaTelegramPlane } from 'react-icons/fa';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useEffect } from 'react';

const Header = () => {
  const text = useTypingEffect("Hi im Sai Pranav !!", 100);

  // Use `useInView` to detect when the component is visible on the screen
  const { ref, inView } = useInView({
    threshold: 0.3, // Trigger animation when the component is at least 50% visible
    triggerOnce: false // Trigger animation every time the component comes into view
  });

  // Use `useAnimation` to trigger the animation
  const animation = useAnimation();

  // Define the animation
  const containerVariants = {
    hidden: { opacity: 0, y: 70 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 , ease: 'easeInOut' } }
  };

  const linkVariants = {
    hidden : { opacity:0 , x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 1} }
  };

  const imageVariants = {
    hidden: { opacity:0 ,scale: 0 },
    visible: { opacity: 1,scale: 1, transition: { duration: 2, ease: 'easeInOut' } },
  }

  // Use `useEffect` to trigger the animation when the component comes into view
  useEffect(() => {
    if (inView) {
      animation.start('visible');
    } else {
      animation.start('hidden');
    }
  }, [inView , animation]);

  return (
    <header id="Home">
      <div className="container header__container" ref={ref}>
        <motion.div
          className="header__content"
          variants={containerVariants}
          initial="hidden"
          animate={animation}
        >
          <motion.h3 className='header__h3'>{text}</motion.h3>

          <motion.h2 className="header__h2">
            Im a{' '}
            <span style={{ fontWeight: 'bold', color: 'orangered' }}>
              <Typewriter
                words={[
                  ' Web Developer',
                  ' Full Stack Developer ',
                  ' Web Designer'
                ]}
                loop={Infinity}
                cursor
                cursorStyle="_"
                typeSpeed={70}
                deleteSpeed={50}
                delaySpeed={1000}
              />
            </span>
          </motion.h2>
          <motion.h4 className="header__h4">#profile page</motion.h4>

          <motion.p>
          Hi everyone, I'm Sai Pranav, a Fullstack Web Developer with a keen interest in learning new technologies. 
          I'm currently focused on enhancing my skills in Artificial Intelligence and exploring Blockchain technology.
          </motion.p>
          <motion.div className="header__cta" >
            <a href="#Contact" className="btn primary">
              Say hi!<FaTelegramPlane />
            </a>
            <a href="#Portfolio" className="btn light">
              My Work
            </a>
          </motion.div>
        </motion.div>
        <motion.div className="header__profile" variants={imageVariants} 
        initial="hidden"
        animate={animation}>
          <img src={HeaderImage} className="header__image"  />
          <div className="shadow"></div>
        </motion.div>
      </div>
      
      <motion.div
        className="header__socials" variants={linkVariants} 
        initial="hidden"
        animate={animation}
      >
        {data.map(item => <a key={item.id} href={item.link} target="_blank" rel='noopener noreferrer'>{item.icon}</a>)}
      </motion.div>
    </header>
  )
}

export default Header;
